import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomainLogicModule} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from "@snelstart/ui-button";
import { SharedUiAlertModule } from "@snelstart/ui-alert";
import { SharedUiDialogModule } from "@snelstart/ui-dialog";
import { SharedUiTabModule } from "@snelstart/ui-tab";
import { SharedUiLoadingModule } from "@snelstart/ui-loading";
import { SpecFormattedexplanationComponent } from "./rapport/spec-formattedexplanation/spec-formattedexplanation.component";
import { SpecFormattedexplanationpolicyComponent } from "./rapport/spec-formattedexplanationpolicy/spec-formattedexplanationpolicy.component";
import { SpecTrialbalanceComponent } from "./rapport/spec-trialbalance/spec-trialbalance.component";
import { FeatureTaxReportDetailsComponent } from './tax-report-details/feature-tax-report-details.component';
import { RapportComponent } from './rapport/rapport.component';
import { TekstComponent } from './rapport/tekst/tekst.component';
import { AccountantsverklaringGenererenComponent } from './rapport/accountantsverklaring-genereren/accountantsverklaring-genereren.component';
import { KoppelenRgsAdminComponent } from './rapport/koppelen-rgs-admin/koppelen-rgs-admin.component';
import { InfoOndernemingComponent } from "./rapport/info-onderneming/info-onderneming.component";
import { InfoRapportageComponent } from "./rapport/info-rapportage/info-rapportage.component";
import { SamenstellingsverklaringComponent } from "./rapport/samenstellingsverklaring/samenstellingsverklaring.component";
import { ZakelijkePartnersComponent } from './rapport/zakelijke-partners-natuurlijke-personen/zakelijke-partners.component';
import { FiscalePositieComponent } from './rapport/fiscale-positie/fiscale-positie.component';
import { ActivaComponent } from './rapport/activa/activa.component';
import { PassivaComponent } from './rapport/passiva/passiva.component';
import { WinstEnVerliesrekeningComponent } from './rapport/winst-en-verliesrekening/winst-en-verliesrekening.component';
import { NubbvComponent } from './rapport/nubbv/nubbv.component';
import { SpecIvaComponent } from './rapport/spec-iva/spec-iva.component';
import { SpecMvaComponent } from './rapport/spec-mva/spec-mva.component';
import { SpecVastgoedbeleggingenComponent } from "./rapport/spec-vastgoedbeleggingen/spec-vastgoedbeleggingen.component";
import { SpecFvaComponent } from './rapport/spec-fva/spec-fva.component';
import { SpecVoorraadComponent } from './rapport/spec-voorraad/spec-voorraad.component';
import { SpecOnderhandenProjectenComponent } from "./rapport/spec-onderhanden-projecten/spec-onderhanden-projecten.component";
import { SpecVorderingenComponent } from './rapport/spec-vorderingen/spec-vorderingen.component';
import { SpecEffectenComponent } from './rapport/spec-effecten/spec-effecten.component';
import { SpecLiquideMiddelenComponent } from './rapport/spec-liquide-middelen/spec-liquide-middelen.component';
import { SpecEigenVermogenNatuurlijkePersonenComponent } from './rapport/spec-eigen-vermogen-natuurlijke-personen/spec-eigen-vermogen-natuurlijke-personen.component';
import { SpecEigenVermogenNatuurlijkPersoonComponent } from './rapport/spec-eigen-vermogen-natuurlijk-persoon/spec-eigen-vermogen-natuurlijk-persoon.component';
import { SpecEigenVermogenRechtspersoonComponent } from './rapport/spec-eigen-vermogen-rechtspersoon/spec-eigen-vermogen-rechtspersoon.component';
import { SpecVoorzieningenComponent } from './rapport/spec-voorzieningen/spec-voorzieningen.component';
import { SpecLanglopendeSchuldenComponent } from './rapport/spec-langlopende-schulden/spec-langlopende-schulden.component';
import { SpecKortlopendeSchuldenComponent } from './rapport/spec-kortlopende-schulden/spec-kortlopende-schulden.component';
import { SpecNettoOmzetComponent } from './rapport/spec-netto-omzet/spec-netto-omzet.component';
import { SpecBedrijfsopbrengstenComponent } from './rapport/spec-bedrijfsopbrengsten/spec-bedrijfsopbrengsten.component';
import { SpecKostenGrondEnHulpstoffenComponent } from './rapport/spec-kosten-grond-en-hulpstoffen/spec-kosten-grond-en-hulpstoffen.component';
import { SpecKostenUitbesteedWerkComponent } from './rapport/spec-kosten-uitbesteed-werk/spec-kosten-uitbesteed-werk.component';
import { SpecLastenPersoneelsbeloningenComponent } from './rapport/spec-lasten-personeelsbeloningen/spec-lasten-personeelsbeloningen.component';
import { SpecOverigeBedrijfskostenComponent } from './rapport/spec-overige-bedrijfskosten/spec-overige-bedrijfskosten.component';
import { SpecResultaatDeelnemingenComponent } from './rapport/spec-resultaat-deelnemingen/spec-resultaat-deelnemingen.component';
import { SpecVrijvalUitHerwaarderingsreserveComponent} from "./rapport/spec-vrijval-uit-herwaarderingsreserve/spec-vrijval-uit-herwaarderingsreserve.component";
import { SpecFinancieleBatenLasten } from './rapport/spec-financiele-baten-lasten/spec-financiele-baten-lasten.component';
import { SpecOvbatenenlastenComponent } from './rapport/spec-ovbatenenlasten/spec-ovbatenenlasten.component';
import { SpecAfschrijvingenIvaMvaComponent } from './rapport/spec-afschrijvingen-iva-mva/spec-afschrijvingen-iva-mva.component';
import { SpecWaardeveranderingenIvaMvaComponent } from "./rapport/spec-waardeveranderingen-iva-mva/spec-waardeveranderingen-iva-mva.component";
import { SpecWaardeveranderingenVastgoedbeleggingenComponent } from "./rapport/spec-waardeveranderingen-vastgoedbeleggingen/spec-waardeveranderingen-vastgoedbeleggingen.component";
import { SpecWaardeverminderingVlottendeActivaComponent } from "./rapport/spec-waardevermindering-vlottende-activa/spec-waardevermindering-vlottende-activa.component";
import { SpecBelastingenComponent } from "./rapport/spec-belastingen/spec-belastingen.component";
import { GrondslagenAlgemeenComponent } from './rapport/grondslagen-algemeen/grondslagen-algemeen.component';
import { GrondslagenBalansComponent } from "./rapport/grondslagen-balans/grondslagen-balans.component";
import { GrondslagenWinstEnVerliesrekeningComponent } from "./rapport/grondslagen-winst-en-verliesrekening/grondslagen-winst-en-verliesrekening.component";
import { ToelichtingAlgemeenComponent } from "./rapport/toelichting-algemeen/toelichting-algemeen.component";
import { ToelichtingContinuiteitComponent } from "./rapport/toelichting-continuiteit/toelichting-continuiteit.component"
import { ToelichtingSchattingenComponent } from "./rapport/toelichting-schattingen/toelichting-schattingen.component"
import { ToelichtingConsolidatieComponent } from "./rapport/toelichting-consolidatie/toelichting-consolidatie.component"
import { ToelichtingFusiesEnOvernamesComponent } from "./rapport/toelichting-fusies-en-overnames/toelichting-fusies-en-overnames.component"
import { ToelichtingBeeindigingBedrijfsactiviteitenComponent } from "./rapport/toelichting-beeindiging-bedrijfsactiviteiten/toelichting-beeindiging-bedrijfsactiviteiten.component"
import { ToelichtingBalansComponent } from "./rapport/toelichting-balans/toelichting-balans.component";
import { ToelichtingNietInBalansOpgenomenActivaVerplichtingenComponent } from "./rapport/toelichting-niet-in-balans-opgenomen-activa-verplichtingen/toelichting-niet-in-balans-opgenomen-activa-verplichtingen.component";
import { ToelichtingBijzonderePostenComponent } from "./rapport/toelichting-bijzondere-posten/toelichting-bijzondere-posten.component";
import { ToelichtingOverigeToelichtingenWinstEnVerliesrekeningComponent } from "./rapport/toelichting-overige-toelichtingen-winst-en-verliesrekening/toelichting-overige-toelichtingen-winst-en-verliesrekening.component";
import { ToelichtingConcessiesComponent } from "./rapport/toelichting-concessies/toelichting-concessies.component";
import { ToelichtingGemiddeldAantalWerknemersComponent } from "./rapport/toelichting-gemiddeld-aantal-werknemers/toelichting-gemiddeld-aantal-werknemers.component";
import { ToelichtingFinancieleInstrumentenComponent } from "./rapport/toelichting-financiele-instrumenten/toelichting-financiele-instrumenten.component";
import { ToelichtingOpAandelenGebaseerdeBetalingenComponent } from "./rapport/toelichting-op-aandelen-gebaseerde-betalingen/toelichting-op-aandelen-gebaseerde-betalingen.component";
import { ToelichtingBezoldigingBestuurdersCommissarissenComponent } from "./rapport/toelichting-bezoldiging-bestuurders-commissarissen/toelichting-bezoldiging-bestuurders-commissarissen.component";
import { ToelichtingLeningenBestuurdersCommissarissenComponent } from "./rapport/toelichting-leningen-bestuurders-commissarissen/toelichting-leningen-bestuurders-commissarissen.component";
import { ToelichtingNogNietUitgeoefendeVerleendeRechtenComponent } from "./rapport/toelichting-nog-niet-uitgeoefende-verleende-rechten/toelichting-nog-niet-uitgeoefende-verleende-rechten.component";
import { ToelichtingGebeurtenissenNaBalansdatumComponent } from "./rapport/toelichting-gebeurtenissen-na-balansdatum/toelichting-gebeurtenissen-na-balansdatum.component";
import { ToelichtingOverigeToelichtingenComponent } from "./rapport/toelichting-overige-toelichtingen/toelichting-overige-toelichtingen.component";
import { OndertekeningRechtspersoonComponent } from './rapport/ondertekening-rechtspersoon/ondertekening-rechtspersoon.component';
import { OndertekeningNatuurlijkePersonenComponent } from './rapport/ondertekening-natuurlijke-personen/ondertekening-natuurlijke-personen.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiAlertModule,
    SharedUiDialogModule,
    SharedUiTabModule,
    DomainLogicModule,
    SharedUiLoadingModule,
    SpecWaardeveranderingenIvaMvaComponent,
    SpecWaardeveranderingenVastgoedbeleggingenComponent,
    SpecWaardeverminderingVlottendeActivaComponent,
    KoppelenRgsAdminComponent,
    FeatureTaxReportDetailsComponent,
    ToelichtingAlgemeenComponent,
    ToelichtingContinuiteitComponent,
    ToelichtingSchattingenComponent,
    ToelichtingConsolidatieComponent,
    ToelichtingFusiesEnOvernamesComponent,
    ToelichtingBeeindigingBedrijfsactiviteitenComponent,
    ToelichtingBalansComponent,
    ToelichtingNietInBalansOpgenomenActivaVerplichtingenComponent,
    ToelichtingBijzonderePostenComponent,
    ToelichtingOverigeToelichtingenWinstEnVerliesrekeningComponent,
    ToelichtingConcessiesComponent,
    ToelichtingGemiddeldAantalWerknemersComponent,
    ToelichtingFinancieleInstrumentenComponent,
    ToelichtingOpAandelenGebaseerdeBetalingenComponent,
    ToelichtingBezoldigingBestuurdersCommissarissenComponent,
    ToelichtingLeningenBestuurdersCommissarissenComponent,
    ToelichtingNogNietUitgeoefendeVerleendeRechtenComponent,
    ToelichtingGebeurtenissenNaBalansdatumComponent,
    ToelichtingOverigeToelichtingenComponent,
    RapportComponent,
    TekstComponent,
    AccountantsverklaringGenererenComponent,
    SamenstellingsverklaringComponent,
    FiscalePositieComponent,
    ActivaComponent,
    InfoOndernemingComponent,
    InfoRapportageComponent,
    ZakelijkePartnersComponent,
    PassivaComponent,
    WinstEnVerliesrekeningComponent,
    GrondslagenAlgemeenComponent,
    GrondslagenBalansComponent,
    GrondslagenWinstEnVerliesrekeningComponent,
    NubbvComponent,
    SpecTrialbalanceComponent,
    SpecBelastingenComponent,
    SpecIvaComponent,
    SpecMvaComponent,
    SpecFvaComponent,
    SpecVorderingenComponent,
    SpecVastgoedbeleggingenComponent,
    SpecOnderhandenProjectenComponent,
    SpecLiquideMiddelenComponent,
    SpecEigenVermogenNatuurlijkePersonenComponent,
    SpecEigenVermogenNatuurlijkPersoonComponent,
    SpecEigenVermogenRechtspersoonComponent,
    SpecFormattedexplanationComponent,
    SpecFormattedexplanationpolicyComponent,
    SpecVoorzieningenComponent,
    SpecLanglopendeSchuldenComponent,
    SpecKortlopendeSchuldenComponent,
    SpecNettoOmzetComponent,
    SpecBedrijfsopbrengstenComponent,
    SpecKostenGrondEnHulpstoffenComponent,
    SpecKostenUitbesteedWerkComponent,
    SpecLastenPersoneelsbeloningenComponent,
    SpecOverigeBedrijfskostenComponent,
    SpecResultaatDeelnemingenComponent,
    SpecVrijvalUitHerwaarderingsreserveComponent,
    SpecFinancieleBatenLasten,
    SpecOvbatenenlastenComponent,
    OndertekeningRechtspersoonComponent,
    OndertekeningNatuurlijkePersonenComponent,
    SpecVoorraadComponent,
    SpecEffectenComponent,
    SpecAfschrijvingenIvaMvaComponent
  ],
  declarations: [
    ],
  exports: [FeatureTaxReportDetailsComponent],
})
export class FeatureTaxReportDetailsModule {}
